import React, { useState, useContext } from 'react';
import styles from './login.module.scss';
import { Context as AuthContext } from '../../Redux/context/AuthContext';
import { useHistory, useLocation } from 'react-router-dom';
import GoogleLogin from 'react-google-login';
import AlertComponent from '../../components/Alerts';
import TermsAndConditionPage from '../TermsAndCondition';

const Login = (props) => {
  const { signin } = useContext(AuthContext);
  let history = useHistory();
  let location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showWorkingHours, setShowWorkingHours] = useState(false);

  const handleLoginSuccess = async (googleData) => {
    let { from } = location.state || {
      from: { pathname: '/dashboard', state: { source: 'from seller login' } },
    };
    const signInResp = await signin({ token: googleData.tokenId });
    if (signInResp.status === 'success') {
      if (signInResp.login_data.tnc && signInResp.login_data.working) {
        history.replace(from);
      } else {
        if (signInResp && signInResp.login_data && !signInResp.login_data.tnc) {
          setShowTerms(true);
        }
        if (signInResp && signInResp.login_data && !signInResp.login_data.working) {
          setShowWorkingHours(true);
        }
      }
    }
  };

  const handleLoginError = () => {
    alert('Error while login. Try after sometime.');
  };

  const onConfirm = () => {
    setShowModal(false);
  };
  const onCancel = () => {
    setShowModal(false);
  };

  return (
    <div className={styles.container}>
      {!showTerms && !showWorkingHours ? (
        <div className={`${styles.formContainer} row m-0`}>
          <div className={styles.loginBox}>
            <span className={styles.formLogo}>
              <img
                alt="arzooo-header-logo"
                className={styles.headerLogo}
                src="https://static.arzoopro.com/images/falcon-logo.png"
              ></img>
            </span>

            {/* <div className="d-flex justify-content-center">
              <GoogleLogin
                clientId={
                  '868881563620-53i2nnhl1jrrrco4015u79214pjnncom.apps.googleusercontent.com'
                }
                buttonText="Log in with Google"
                onSuccess={handleLoginSuccess}
                onFailure={handleLoginError}
                cookiePolicy={'single_host_origin'}
              />
            </div> */}
          </div>
        </div>
      ) : null}
      {showModal ? (
        <div>
          <AlertComponent
            onConfirm={onConfirm}
            onCancel={onCancel}
            showCancel={false}
            confirmBtnText="OK"
            msg="You are not authorized as a falcon seller with us. Please get in touch on falcon@arzooo.com to register as a supplier and we will get back to you."
            btn1Style={{
              background: '#22C0E7',
              padding: '0.4rem 1.8rem',
              outline: 'none',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
            }}
          />
        </div>
      ) : null}
      {showTerms || showWorkingHours ? (
        <TermsAndConditionPage showTerms={showTerms} showWorkingHours={showWorkingHours} />
      ) : null}
    </div>
  );
};

export default Login;
